"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var SectionHeader_1 = __importDefault(require("../../../SectionHeader"));
var SelectOptions_1 = __importDefault(require("./SelectOptions"));
var ApartmentTableContext_1 = require("../../../../../contexts/ApartmentTableContext");
var ApartmentsTable_1 = __importDefault(require("./ApartmentsTable"));
var filters_1 = require("../../../../../helpers/filters");
var Icon_1 = __importDefault(require("../../../../Icon"));
var PostViewContentTypes_1 = require("../../../../../constants/PostViewContentTypes");
var style_module_scss_1 = __importDefault(require("./style.module.scss"));
var ApartmentsSection = function (_a) {
    var postData = _a.postData, redirectToMortgageSection = _a.redirectToMortgageSection, setPostMedia = _a.setPostMedia, handleScrollToShowMobileMedias = _a.handleScrollToShowMobileMedias, isMortgageButtonClicked = _a.isMortgageButtonClicked, setIsMortgageButtonClicked = _a.setIsMortgageButtonClicked, setApartmentsTablePositionY = _a.setApartmentsTablePositionY, isRent = _a.isRent;
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState(), filters = _b[0], setFilters = _b[1];
    var aptTableRef = react_1.useRef(null);
    var _c = react_1.useState(), activeApartmentId = _c[0], setActiveApartmentId = _c[1];
    var apartmentAvailabilities = react_1.useMemo(function () { return filters_1.groupByPostAvailability(postData.sections.apartment_info); }, []);
    react_1.useEffect(function () {
        aptTableRef.current &&
            setApartmentsTablePositionY(aptTableRef.current.offsetTop);
    }, [aptTableRef]);
    var handleUpdateFilters = react_1.useCallback(function (filters) {
        setFilters(filters);
    }, [filters]);
    return (react_1.default.createElement(ApartmentTableContext_1.ApartmentContext.Provider, { value: { activeApartmentId: activeApartmentId, setActiveApartmentId: setActiveApartmentId } },
        react_1.default.createElement("div", { className: "section-data", ref: aptTableRef },
            react_1.default.createElement("div", { className: style_module_scss_1.default.header },
                react_1.default.createElement(SectionHeader_1.default, { title: postData.propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO
                        ? t('POST_PREVIEW.HOUSES_INFO').toUpperCase()
                        : postData.propertyType ===
                            PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO
                            ? t('POST_PREVIEW.AVAILABLE_APARTMENTS_INFO').toUpperCase()
                            : postData.propertyType ===
                                PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO
                                ? t('POST_PREVIEW.AVAILABLE_COMMERCIALS_INFO').toUpperCase()
                                : t('POST_PREVIEW.AVAILABLE_APARTMENTS_INFO').toUpperCase() }),
                react_1.default.createElement("div", { className: style_module_scss_1.default.filter_title },
                    react_1.default.createElement(Icon_1.default, { semanticName: "filter" }),
                    ' ',
                    react_1.default.createElement("span", null, t('POST_PREVIEW.FILTER_BY')))),
            react_1.default.createElement(SelectOptions_1.default, { handleUpdateFilters: handleUpdateFilters, apartmentAvailabilities: apartmentAvailabilities, propertyType: postData.propertyType }),
            react_1.default.createElement("div", { className: style_module_scss_1.default.apt_table },
                react_1.default.createElement(ApartmentsTable_1.default, { apartments: postData.sections.apartment_info, filters: filters, postData: postData, redirectToMortgageSection: redirectToMortgageSection, setPostMedia: setPostMedia, handleScrollToShowMobileMedias: handleScrollToShowMobileMedias, isMortgageButtonClicked: isMortgageButtonClicked, setIsMortgageButtonClicked: setIsMortgageButtonClicked, isRent: isRent })))));
};
exports.default = ApartmentsSection;
